<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiPaperclip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2 style="word-break: normal;">
                            Out-Patient Procedure Approval Result
                        </h2>
                    </v-col>
                </v-row>
            </v-card-title>
        </v-container>
        <v-container v-if=" getOppaResult.OPPAN_NO" :style="`padding: ${screen_width > 959 ? '0 30px' : screen_width > 599 ? '0' : '0'};`">
            <v-card :style="`padding: ${screen_width > 599 ? '10px 20px' : '0'}`">
                <v-alert
                    text
                    color="#4ABAA4"
                    style="border-left: 8px solid #4ABAA4;"
                >
                    <div style="color: black; text-align: justify;">
                        Your request for out-patient consultation on {{ getOppaResult.HOSP_NAME }} <span v-if="getOppaResult.DOCTOR || (getOppaResult.DOCTOR).trim() != ''">- DR. {{ getOppaResult.DOCTOR }}</span> was approved.
                        The consultation and referral authorization slip is now available for download by clicking the button below.
                        This slip is also sent to your email <b style="color: #00BA94;">{{ getOppaResult.EMAIL }}</b>. You can also download this slip from the History page. This slip is issued on {{ getOppaResult.DATE_ISSUED }} and is valid until {{ getOppaResult.VALID_UNTIL }}.
                    </div>
                </v-alert>
                <v-row :style="`margin: ${screen_width > 599 ? '10px 17px' : '10px 0'};`">
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Approval Number:</span><b>{{ getOppaResult.OPPAN_NO }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Status:</span><b style="color: #00BA94;">{{ getOppaResult.APPROVED ? 'APPROVED' : 'DISAPPROVED' }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-divider class="d-sm-none my-3" /><span style="display: block; color: #555;">Date Issued:</span><b>{{ getOppaResult.DATE_ISSUED }}</b>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <span style="display: block; color: #555;">Valid Until:</span><b>{{ getOppaResult.VALID_UNTIL }}</b>
                    </v-col>
                </v-row>
                <v-card :style="`padding: ${screen_width > 599 ? '28px' : '0 10px'}; background-color: #F9F9F9;`">
                    <v-row>
                        <v-col cols="12" sm="6">
                            <div>
                                <span style="display: block; color: #555;">Medical Provider:</span><b>{{ getOppaResult.HOSP_NAME }}</b>
                            </div>
                            <div class="mt-4">
                                <span style="display: block; color: #555;">Specialist:</span><span v-if="getOppaResult.DOCTOR || (getOppaResult.DOCTOR).trim() != ''"><b>DR. {{ getOppaResult.DOCTOR }}</b></span><span v-else><b>Any HMI Affiliated Doctor</b></span>
                            </div>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-divider class="d-sm-none my-3" />
                            <div>
                                <span style="display: block; color: #555;">Patient Name:</span><b>{{ getOppaResult.NAME }}</b>
                            </div>
                            <div class="mt-4">
                                <span style="display: block; color: #555;">Date of Birth:</span><b>{{ getOppaResult.DOB }}</b>
                            </div>
                        </v-col>
                    </v-row>
                </v-card>
                <p :style="`margin: ${screen_width > 599 ? '28px' : '30px 10px 10px 10px'}; font-size: 16px; color: #222; text-align: justify;`">
                    <v-icon color="orange">
                        {{ mdiAlert }}
                    </v-icon>&nbsp;Disclaimer: The approval for the referenced service or treatment is provisional. If, upon further review, it is determined that the service or treatment is not eligible for coverage under your health card plan, you may be billed back for any or all costs incurred.
                </p>
                <v-container v-if="getOppaResult.OPPAN_NO" style="text-align: center;">
                    <v-btn class="teal white--text" @click="getSlip()">
                        <v-icon>{{ mdiDownload }}</v-icon>&nbsp;
                        <h1>Download</h1>
                    </v-btn>
                    <v-btn style="margin: 15px;" @click="goBack()">
                        <h1>Done</h1>
                    </v-btn>
                    <h1 style="color: #00BA94;">
                        Should you need assistance, kindly contact <a style="color: #00BA94" href="https://www.hmi.com.ph/contact">HMI</a>.
                    </h1>
                </v-container>
            </v-card>
        </v-container>
    </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { saveAs } from 'file-saver'
import { mdiAlert, mdiDownload, mdiPaperclip } from '@mdi/js'
import { base64ToBlob } from '../../../utils/helpers'
export default {
    data: () => {
        return({
            mdiAlert, mdiDownload, mdiPaperclip,
            opan_n: '',
            screen_width: document.documentElement.clientWidth + 9
        })
    },
    computed: {
        ...mapGetters(['getOppaResult', 'getOppaFile']),
        fileDownload: {
            get() {
                return this.getOppaFile
            }
        }
    },
    async mounted () {
        this.opan_n = this.$route.query.OPPAN
        this.fetchSlip({
            OPPAN_PDF_NAME: this.opan_n,
            MEMBN: this.$cookies.get('usermembn')
        })
        window.addEventListener('resize', this.onResize)
    },
    destroyed() {
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['fetchSlip', 'getCsrfToken']),
        onResize() {
            this.screen_width = document.documentElement.clientWidth
        },
        goBack() {
            this.$router.push('/dashboard/consultation')
        },
        getSlip() {
            const file = this.fileDownload
            const blob = base64ToBlob(file.file, 'application/pdf')
            // const url = URL.createObjectURL(blob)
            // console.log(url);
            saveAs(blob, `${this.getOppaResult.OPPAN_NO}.pdf`)
        }
    }
}
</script>

<style scoped>
.requestWrapper {
    height: 10;
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-wrap: wrap;
}
.memberInfoCard {
    width: 70%;
    margin: auto;
}

section {
  width: 100%;
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
.user-card {
  width: 95%;
}
h1 {
    font-size: 18px;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }

  /* Member Card wrapper */
  .user-card {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .user-card {
    width: 80%;
  }
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}

@media (min-width: 968px) and (max-width: 1264px) {
  /* Navbar */
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
}
</style>
